// Export a customer's proxies (My Proxies, and Admin > Customers) as CSV: active licences only, every detail,
// one proxy per row (opens in Excel / Google Sheets).

export const isActiveProxy = (p) => String(p?.license_status || p?.status || '').toUpperCase() === 'ACTIVE'
  && (!p?.expired_date || new Date(p.expired_date).getTime() > Date.now());

const loginPart = (p) => (p.authentication_user ? ':' + p.authentication_user : '');
const lineFor = (p, port) => `${p.host_domain}:${port}${loginPart(p)}`;
// "7 Days - Vodafone Perth 5" -> ["7 Days", "Vodafone Perth 5"]
const pkParts = (p) => { const s = String(p?.package_name || p?.modem_name || ''); const i = s.indexOf(' - '); return i > 0 ? [s.slice(0, i), s.slice(i + 3)] : ['', s]; };
const when = (v) => (v ? new Date(v).toISOString().slice(0, 16).replace('T', ' ') + ' UTC' : '');

// a cell: quoted when needed; a leading = + - @ is made plain text so a spreadsheet never runs it as a formula
const cell = (v) => {
  let s = String(v ?? '');
  if (/^[=+\-@]/.test(s)) s = "'" + s;
  return /[",\r\n]/.test(s) ? `"${s.replace(/"/g, '""')}"` : s;
};

export function proxiesCsv(list, { email = '', rotationLink = (p) => p.rotation_link || '' } = {}) {
  const head = [...(email ? ['Customer'] : []), 'Server', 'Package', 'Status', 'Expires', 'Host', 'HTTP port', 'SOCKS5 port', 'Login', 'IP whitelist', 'HTTP line', 'SOCKS5 line', 'Rotation link'];
  const rows = (list || []).filter(isActiveProxy).map((p) => {
    const [pkg, server] = pkParts(p);
    return [...(email ? [email] : []), server, pkg, 'Active', when(p.expired_date), p.host_domain, p.http_port, p.socket_port || p.http_port,
      p.authentication_user || '', String(p.authorization_ips || '').replace(/,/g, ' '), lineFor(p, p.http_port), lineFor(p, p.socket_port || p.http_port), rotationLink(p)];
  });
  return '﻿' + [head, ...rows].map((r) => r.map(cell).join(',')).join('\r\n') + '\r\n';   // the BOM lets Excel read it as UTF-8
}

export function downloadText(name, text, type) {
  const url = URL.createObjectURL(new Blob([text], { type }));
  const a = document.createElement('a');
  a.href = url; a.download = name;
  document.body.appendChild(a); a.click(); a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}

export const exportName = (who, ext) => `proxies${who ? '-' + String(who).replace(/@.*/, '').replace(/[^\w.-]+/g, '_') : ''}-${new Date().toISOString().slice(0, 10)}.${ext}`;
